
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Route, Routes } from "react-router-dom";
import Api from "services/api"
import { ListLayout } from "components/common/ListLayout";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { convertTimeToUTC } from "helpers/convertTimeToUTC";
import { setAddAppointmentPopup } from "slices/appointmentSlice";
import AppointmentView from "./appointment/view";
import { interpreterAppointmentsSelector } from "slices/interpreter/appointmentSlice";
import { fetchInterpreterAppointments } from "slices/interpreter/appointmentSlice";
import { getBackgroundStyle } from "components/common/TableColor";
import moment from "moment";
import formatDateTimeByTimezone from 'hooks/formatDateTimeByTimezone';
import JoinInterpreterVideoCall from "./JoinInterpreterVideoCall/JoinInterpreterVideoCall";
import { userSelector } from "slices/userSlice";
import { useTranslation } from "react-i18next";
const apiService = new Api();

const appointmentRoutes = [
  {
    path: "",
    component: <AppointmentList />,
  },
  {
    path: "view/:id",
    component: <AppointmentView />,
  },
  {
    path: "view/:id/join-room-call",
    component: <JoinInterpreterVideoCall />,
  }
]

export const AppointmentRoutes = () => {

  return (
    <Routes>
      {appointmentRoutes.map(({ path, component }) => (
        <Route key={path} path={path} element={component} />
      ))}
    </Routes>
  )

}

function AppointmentList() {
  const { t } = useTranslation();
  const dispatch = useDispatch()
  const { interpreterAppointments: appointments, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(interpreterAppointmentsSelector);
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}

  });
  const refAddutton = React.useRef(null);

  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState([10])
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: 'name',
    sortDirection: 'asc',
  });

  React.useEffect(() => {
    dispatch(fetchInterpreterAppointments())
  }, [])

  const handleAddAppointmentPopUp = (item) => {
    dispatch(setAddAppointmentPopup({
      show: true,
      item,
    }))
  };

  const handleChange = (e) => {
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };


  //#region TABLE HEAD 

  const renderTableHeader = React.useCallback(() => {
    const callBack = (dir, sortBy) => {
      setSortConfig({ sortBy, sortDirection: dir })
      dispatch(fetchInterpreterAppointments(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
    }
    return (
      <tr>
        <th className="col-1">
          <div className="row_check">
            <span>#</span>
          </div>
        </th>
        <th>
          <TableHeaderItem
            title={t("table.appid")}
            sortBy="appid"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th>
          <TableHeaderItem
            title={t("table.service")}
            sortBy="type"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th>
          <TableHeaderItem
            title={t("table.date")}
            sortBy="date"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title={t("table.language")}
            sortBy="language_id"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title={t("table.accounts")}
            sortBy="account_id"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th>
          <TableHeaderItem
            title={t("table.creationDate")}
            sortBy="created_at"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th className="col-1">
          <TableHeaderItem
            title={t("table.status")}
            sortBy="status"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
      </tr>
    )
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems, appointments, t]);

  //#endregion


  //#region TABLE BODY

  const renderTableContent = React.useCallback(() => {
    return (
      appointments && appointments?.map((appointment, index) => (
        <AppointmentItem appointment={appointment} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddAppointmentPopUp} current_page={current_page} pageLength={pageLength} />
      ))
    )
  }, [appointments, selectedItems, current_page]);

  //#endregion


  return (
    <ListLayout
      heading={t("routes.appointments")}
      time={true}
      addButtonDisabled={true}
      title=""
      renderTableHeader={renderTableHeader}
      renderTableContent={renderTableContent}
      totalPages={totalPages}
      fetchList={fetchInterpreterAppointments}
      selectedItems={selectedItems}
      refAddutton={refAddutton}
      addForm={addForm}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      loader={loader}
      searchPlaceholder={t("appointments.searchPlaceholder")}
      noOfItems={total}
      refAddPopUp="#addAppointmentPopUp"
      defaultPageLength={pageLength}
    >
    </ListLayout>
  )

}


const AppointmentItem = ({
  appointment, index, current_page, pageLength
}) => {
  const { t } = useTranslation();
  const { user } = useSelector(userSelector);
  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);


  const statuses = [
    {
      label: t("legend.available"),
      value: "available",
    },
    {
      label: t("legend.assigned"),
      value: "assigned",
    }, {
      label: t("legend.dnc"),
      value: "dnc",
    },
    {
      label: t("legend.cnc"),
      value: "cnc",
    },
    {
      label: t("legend.completed"),
      value: "completed",
    },
    {
      label: t("legend.cancelled"),
      value: "cancelled",
    }
  ]

    const ClientTimezone = appointment?.interpreter?.timezone;
    const rawDatetime = appointment?.datetime;
    
    // ➤ Time in UTC (default)
    const formattedDefaultTime = moment.utc(rawDatetime).format('MMM D, YYYY hh:mm A');
    
    const formattedClientTime =  ClientTimezone ? moment.utc(rawDatetime).tz(ClientTimezone?.name).format('MMM D, YYYY hh:mm A') : formattedDefaultTime;

    const appointmentTimezoneName = appointment?.appointment_details?.timezone?.name;
        const interpreterTimezoneName = appointment?.interpreter?.timezone?.name || user?.timezone?.name;
    
        const formattedAppointmentDateTime = (() => {
          if (!appointment?.datetime) return t("common.nA");
          if (appointmentTimezoneName && interpreterTimezoneName) {
            return moment
              .tz(appointment.datetime, appointmentTimezoneName)
              .tz(interpreterTimezoneName)
              .format("MMM D, YYYY hh:mm A");
          }
          if (interpreterTimezoneName) {
            return moment.utc(appointment.datetime)
              .tz(interpreterTimezoneName)
              .format("MMM D, YYYY hh:mm A");
          }
          return moment(appointment.datetime).format("MMM D, YYYY hh:mm A");
        })();
    

  return (
    <tr>
      <td style={getBackgroundStyle(appointment?.status)}>
        <div className="row_check">
          <span>{serial}</span>
        </div>
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        <Link className='link_preview' to={`/interpreter/appointments/view/${appointment?.id}`}>
          {appointment?.appid}
        </Link>
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        {appointment?.type || t("common.nA")}
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
         { formattedAppointmentDateTime || t("common.nA")}
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        {appointment?.language?.name || t("common.nA")}
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        {appointment?.accounts?.user?.name || t("common.nA")}
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        { moment.utc(appointment.created_at).tz(ClientTimezone?.name).format('MMM D, YYYY hh:mm A')}
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        {statuses?.find(status => status.value == appointment?.status)?.label || appointment?.status || t("common.nA")}
      </td>
    </tr>
  )
}


export default AppointmentList;
